import { GatewaysCircleOptions } from './../../../shared/constants/gateway.constant';
import { Component, AfterViewInit, ChangeDetectorRef, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { Pluviometers } from '../../../shared/constants/pluviometer.constant';
import { bikeIcon, co2SensorIcon, currentLocationIcon, gatewayIcon, hospitalIcon, levelSensorBlueIcon, levelSensorIcon, panelIcon, pluviometerIcon, policeIcon, restrictionIcon, sensorIcon, soundSensorIcon, trashIcon, wifiIcon } from '../../../shared/constants/icons.constant';
import { Gateways } from '../../../shared/constants/gateway.constant';
import { CommonModule, NgFor } from '@angular/common';
import { TrashContainers } from '../../../shared/constants/trash-containers';
import { getBaseSensorPopUp, getCurrentLocationPopUp, getGatewayPopUp, getGenericPanelPopUp, getGenericSensorPopUp, getPluviometerPopUp, getTrashPopUp } from '../../../shared/constants/popup.function';
import { DialogModule } from 'primeng/dialog';
import { RouterModule } from '@angular/router';
import { IotCoreGAMCService } from '../../../shared/services/iot-core.service';
import { HttpClientModule } from '@angular/common/http';
import { Hospitals } from '../../../shared/constants/hospital.constant';
import { Police } from '../../../shared/constants/police.constant';
import { BadgeModule } from 'primeng/badge';
import { WifiCircleOptions, WifiPoints } from '../../../shared/constants/wifi.constant';
import { FormsModule } from '@angular/forms';
import { Lines } from '../../../shared/constants/transport-lines.constant';
import { DialogService } from 'primeng/dynamicdialog';
import { SafeTaxiCheckerComponent } from '../../../shared/components/safe-taxi-checker/safe-taxi-checker.component';
import { catchError, filter, firstValueFrom, map, of, Subscription } from 'rxjs';
import { IotCo2Service } from '../../../shared/services/iot-co2.service';
import { Panels } from '../../../shared/constants/panel.constant';
import { TabMenuModule } from 'primeng/tabmenu';
import { LoaderService } from '../../../shared/services/loader.service';
import { WebsocketService } from '../../../shared/services/webSocket.service';
import { EMCO2List } from '../../../shared/constants/EMCO2.constant';
import { getCheckboxSettings } from '../../../shared/constants/sensor.functions';
import { PreviewSensorDataComponent } from '../../../sensors/preview-data-sensor/preview-data-sensor.component';
import { WS302List } from '../../../shared/constants/WS302.constant';
import { EMUDLList } from '../../../shared/constants/EMUDL.constant';
import { EM310List } from '../../../shared/constants/em310.constant';
import { CiCoreApiService } from '../../../shared/services/ci-core-api.service';
import { WebsocketrxService } from '../../../shared/services/websocketrx.service';

@Component({
  selector: 'app-map',
  standalone: true,
  imports: [NgFor, CommonModule, DialogModule, RouterModule, HttpClientModule, BadgeModule, FormsModule, TabMenuModule, SafeTaxiCheckerComponent, PreviewSensorDataComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    IotCoreGAMCService,
    DialogService,
    IotCo2Service,
    CiCoreApiService
  ],
  templateUrl: './map.component.html'
})
export class MapComponent implements AfterViewInit, OnDestroy, OnInit {

  private _map!: L.Map;

  private readonly _baseMapURl: string = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png';


  public _currentLocationMarker!: L.Marker;
  private _pluviometerMarkers: L.Marker[] = [];
  private _gatewayMarkers: L.Marker[] = [];
  private _trashMarkers: L.Marker[] = [];
  private _hospitalMarkers: L.Marker[] = [];
  private _policeMarkers: L.Marker[] = [];
  private _wifiMarkers: L.Marker[] = [];
  private _panelMarkers: L.Marker[] = [];

  //Sensor list and markers
  private _EM310Sensors: any[] = EM310List;
  private _EM310Markers: L.Marker[] = [];
  private _CO2Sensors: any[] = EMCO2List;
  private _CO2Markers: L.Marker[] = [];
  private _WS302Sensors: any[] = WS302List;
  private _WS302Markers: L.Marker[] = [];
  private _EMUDLSensors: any[] = EMUDLList;
  private _EMUDLMarkers: L.Marker[] = [];

  //Gateway list and markers
  private _gatewayCircles: L.Circle[] = [];
  private _wifiCirles: L.Circle[] = [];
  private _gateways: any[] = [];

  public lines = Lines;
  public filteredLines: any[] = Lines;
  public searchQuery: string = '';
  public selectedLine: any;
  public showResults: boolean = false;
  private _geoJsonLineLayer: any;
  private _currentGeoJsonFile: any;

  private _geoJsonRestrictionLayer: any;
  private _geoJsonBikewayLayer: any;

  public checkedItemsLength: number = 0;
  public isVisible: boolean = false;
  public selectedTab: any = '';
  public mapId!: string;
  public showTaxiChecker: boolean = false;

  private activeLayers = new Set<any>();

  private _subscription: Subscription;

  public items = [
    {
      id: 'all',
      label: 'Inicio',
      icon: ''
    },
    {
      id: 'interest',
      label: 'Interés',
      icon: 'pi pi-map-marker'
    },
    {
      id: 'sensor',
      label: 'Sensores',
      icon: 'pi pi-sitemap'
    }
  ];

  public checkboxItems = [
    {
      id: 'location',
      tabs: 'all',
      label: 'Tu ubicación',
      isChecked: false,
      functions: [],
      icon: currentLocationIcon.options.iconUrl,
      disabled: true
    },
    {
      id: 'panel',
      tabs: 'all sensor',
      label: 'Panel inteligente',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('panel')
      ],
      icon: panelIcon.options.iconUrl,
      disabled: false,
      layers: ['panel']
    },
    {
      id: 'wifi',
      tabs: 'all interest',
      label: 'Punto WiFi',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('wifi'),
        (event: any) => this.showHidePin('wifiCircle')
      ],
      icon: wifiIcon.options.iconUrl,
      disabled: false,
      layers: ['wifi', 'wifiCircle']
    },
    {
      id: 'trash',
      tabs: 'interest',
      label: 'Basurero soterrado',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('trash')
      ],
      icon: trashIcon.options.iconUrl,
      disabled: false,
      layers: ['trash']
    },
    {
      id: 'hospital',
      tabs: 'interest',
      label: 'Hospital, Clínica',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('hospital')
      ],
      icon: hospitalIcon.options.iconUrl,
      disabled: false,
      layers: ['hospital']
    },
    {
      id: 'police',
      tabs: 'interest',
      label: 'Policia',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('police')
      ],
      icon: policeIcon.options.iconUrl,
      disabled: false,
      layers: ['police']
    },
    {
      id: 'pluviometer',
      tabs: 'sensor',
      label: 'Pluviómetro',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('pluviometer')
      ],
      icon: pluviometerIcon.options.iconUrl,
      disabled: false,
      layers: ['pluviometer']
    },
    {
      id: 'gateway',
      tabs: 'sensor',
      label: 'Antena IoT',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('gateway'),
        (event: any) => this.showHidePin('gatewayCircle')
      ],
      icon: gatewayIcon.options.iconUrl,
      disabled: false,
      layers: ['gateway', 'gatewayCircle']
    },
    {
      id: 'emco2',
      tabs: 'sensor',
      label: 'Sensor CO2',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('/topic/emco2'),
      ],
      icon: co2SensorIcon.options.iconUrl,
      disabled: false,
      layers: ['sensor']
    },
    // {
    //   id: 'em310',
    //   tabs: 'all sensor',
    //   label: 'Sensor de distancia',
    //   isChecked: false,
    //   functions: [
    //     (event: any) => this.showHidePin('/topic/em310'),
    //   ],
    //   icon: levelSensorIcon.options.iconUrl,
    //   disabled: false,
    //   layers: ['sensor']
    // },
    {
      id: 'ws302',
      tabs: 'all sensor',
      label: 'Sensor de sonido',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('/topic/ws302'),
      ],
      icon: soundSensorIcon.options.iconUrl,
      disabled: false,
      layers: ['sensor']
    },
    {
      id: 'emudl',
      tabs: 'all sensor',
      label: 'Sensor de distancia',
      isChecked: false,
      functions: [
        (event: any) => this.showHidePin('/topic/emudl'),
      ],
      icon: levelSensorBlueIcon.options.iconUrl,
      disabled: false,
      layers: ['sensor']
    }
  ];

  public filteredCheckboxItems = this.checkboxItems;

  constructor(
    private _ciCoreApi: CiCoreApiService,
    private _webSocketService: WebsocketService,
    private _loaderService: LoaderService,
    private _webSocketRxService: WebsocketrxService,
    private _cdr: ChangeDetectorRef) {
    this.mapId = 'ciMap';
    this._subscription = new Subscription();
    localStorage.clear();
  }

  message: string | null = null;
  private messageSub?: Subscription;
  private subscriptions = new Map<string, Subscription>();

  ngOnInit() {
  }

  ngAfterViewInit() {
    this._initializeMap();
    this._EM310Sensors = this.setElementList('/topic/em310', EM310List);
    this._CO2Sensors = this.setElementList('/topic/emco2', EMCO2List);
    this._WS302Sensors = this.setElementList('/topic/ws302', WS302List);
    this._EMUDLSensors = this.setElementList('/topic/emudl', EMUDLList);
    this._initializeSensorsAndMarkers(['/topic/em310', '/topic/emco2', '/topic/ws302', '/topic/emudl']);
  }

  ngOnDestroy() {
    this.messageSub?.unsubscribe();
    this._webSocketRxService.disconnect();
  }

  private _initializeSensorsAndMarkers(topics: string[]) {
    topics.forEach(topic => {
      let sensors = this._getList(topic);
      let icon = this._getIcon(topic);
      let markers = this._generateSensorMarkers(sensors, icon, topic);

      this._updateMarkerList(topic, markers);

      markers.forEach((marker: L.Marker) => {
        if (!this._map.hasLayer(marker)) {
          marker.addTo(this._map);
        } else {
          this._map.removeLayer(marker);
        }
      });

      if (topic === '/topic/em310') this._EM310Sensors = sensors;
      if (topic === '/topic/emco2') this._CO2Sensors = sensors;
      if (topic === '/topic/ws302') this._WS302Sensors = sensors;
      if (topic === '/topic/emudl') this._EMUDLSensors = sensors;
    });
  }

  private _initializeMap(): void {
    this._map = new L.Map(this.mapId, { zoomAnimation: true, minZoom: 12 });
    this._map.locate({ setView: true, enableHighAccuracy: true });

    this._map.on('locationfound', (e: any) => this._onLocationFound(e));
    this._map.on('locationerror', () => {
      this._setCbbaLocation();
    });

    this._map.on('load', (e: any) => this._fillMapRoutes());
    this._map.on('load', (e: any) => this._fillMapLocations());

    L.tileLayer(this._baseMapURl, { attribution: '© OpenStreetMap' }).addTo(this._map);
  }

  private setElementList(topic: string, baseList: any) {
    const list: any = localStorage.getItem(topic);

    return JSON.parse(list) || baseList;
  }

  //Location - navigation
  public goToCurrentLocation() {
    this._currentLocationMarker.openPopup();
    this._map.setView(this._currentLocationMarker.getLatLng());

    setTimeout(() => {
      this._map.setZoom(16);
    }, 800);

    this._cdr.detectChanges();
  }

  private _setCbbaLocation() {
    const defaultLat = -17.387962727660373;
    const defaultLong = -66.1557113167231;

    this._map.setView(new L.LatLng(defaultLat, defaultLong), 13);
  }

  // TabMenu
  public onTabChange(event: any) {
    this.selectedTab = event.id;
    this._filterItems();
  }

  private _filterItems() {
    this.filteredCheckboxItems = this.checkboxItems.filter(item => item.tabs?.includes(this.selectedTab));
    this._cdr.detectChanges();
  }

  //Routes
  private _fillMapRoutes(): void {
    this._loadGeoJson('bikeway', this._geoJsonBikewayLayer);
    this._loadGeoJsonPolyline('restriction', this._geoJsonRestrictionLayer, 'Restricción vehicular');
  }

  private _loadGeoJson(fileName: string, layerItem: any, color: string = '#ae1857'): void {
    this._loaderService.show();
    const filePath = this._getGeoJsonFilePath(fileName);

    const routeCheckBoxItem = {
      label: this._getCheckboxName(fileName),
      isChecked: false,
      functions: [
        (event: any) => this.showHideRoute(layerItem)
      ],
      icon: this._getIcon(fileName).options.iconUrl,
      disabled: false,
      id: fileName,
      tabs: 'all interest',
      layers: [fileName]
    }

    if (filePath) {
      fetch(filePath)
        .then(response => response.json())
        .then(geoJson => {
          layerItem = L.geoJSON(geoJson, { style: { color: color } });
          this.checkboxItems.splice(1, 0, routeCheckBoxItem);
          this.filteredCheckboxItems.splice(1, 0, routeCheckBoxItem);
          this._loaderService.hide();
        })
        .catch((error: any) => {
          this._loaderService.hide();
          console.error('Error loading GeoJSON file:', error)
        });
    } else {
      this._loaderService.hide();
      console.error('Invalid GeoJSON file name:', fileName);
    }
  }

  private _getGeoJsonFilePath(fileName: string): string | null {
    switch (fileName) {
      case 'bikeway':
        return 'assets/geojson/bikeway.geojson';

      case 'restriction':
        return 'assets/geojson/restriction.geojson';

      default:
        return null;
    }
  }

  public showHideRoute(layerItem: any) {
    if (this._map.hasLayer(layerItem)) {
      this._map.removeLayer(layerItem);
    } else {
      this._map.addLayer(layerItem);
      this._map.fitBounds(layerItem.getBounds());
    }
  }

  // Transport
  public showHideResults() {
    this.showResults = !this.showResults;
    this.searchQuery = '';

    this._cdr.detectChanges();
  }

  public onFocus() {
    this.showResults = true;
    this._cdr.detectChanges();
  }

  public onInputChange() {
    this.filteredLines = [];

    this.filteredLines = this.lines.filter(line =>
      line.line.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
    this._cdr.detectChanges();
  }

  public clearInput() {
    this.searchQuery = '';
    this.filteredLines = Lines;

    this._cdr.detectChanges();
  }

  public removeSelectedLine() {
    this.selectedLine = undefined;
    this.filteredLines = Lines;
    this.searchQuery = '';
    this._map.removeLayer(this._geoJsonLineLayer);
    this._geoJsonLineLayer = null;
    this.showResults = false;

    if (this._currentLocationMarker) {
      this._map.setView(this._currentLocationMarker.getLatLng(), 16);
      this._currentLocationMarker.openPopup();
    }

    this._cdr.detectChanges();
  }

  public markLineRoute(fileName: string, index: number) {
    this.selectedLine = this.filteredLines[index];
    this.showResults = false;

    this._loadLineGeoJson(fileName);
    this._currentLocationMarker?.closePopup();
    this._cdr.detectChanges();
  }

  private _loadLineGeoJson(item: any) {
    this._loaderService.show();
    const filePath = item.filePath;

    if (filePath) {
      fetch(filePath)
        .then(response => response.json())
        .then(geoJson => {
          if (this._geoJsonLineLayer) {
            if (this._currentGeoJsonFile === item.filePath) {
              this._map.removeLayer(this._geoJsonLineLayer);
              this._geoJsonLineLayer = undefined;
              this._currentGeoJsonFile = undefined;
              return;
            } else {
              this._map.removeLayer(this._geoJsonLineLayer);
              this._geoJsonLineLayer = undefined;
            }
          }

          if (geoJson) {
            this._geoJsonLineLayer = L.geoJSON(geoJson, {
              style: (feature) => {
                const defaultColor = 'blue';
                return {
                  color: feature?.properties.Color || defaultColor,
                  weight: 3,
                  lineCap: 'round'
                };
              }
            }
            );
            this._geoJsonLineLayer.addTo(this._map);
            this._map.fitBounds(this._geoJsonLineLayer.getBounds());

            this._currentGeoJsonFile = item.filePath;
            this._loaderService.hide();
          } else {
            this._geoJsonLineLayer = undefined;
            this._currentGeoJsonFile = undefined;
            this._loaderService.hide();
          }
        })
        .catch((error: any) => {
          this._loaderService.hide();
          console.error('Error loading GeoJSON file:', error)
        });
    } else {
      this._loaderService.hide();
      console.error('Invalid GeoJSON file name:', item.line);
    }
  }

  private _loadGeoJsonPolyline(fileName: string, layerItem: any, text?: string) {
    this._loaderService.show();
    const filePath = this._getGeoJsonFilePath(fileName);

    const routeCheckBoxItem = {
      label: this._getCheckboxName(fileName),
      isChecked: false,
      functions: [
        (event: any) => this.showHideRoute(layerItem)
      ],
      icon: this._getIcon(fileName).options.iconUrl,
      disabled: false,
      id: fileName,
      tabs: 'all interest',
      layers: [fileName]
    };

    if (filePath) {
      fetch(filePath)
        .then(response => response.json())
        .then(geoJson => {
          const polygonCoordinates = [...geoJson.features[0].geometry.coordinates, geoJson.features[0].geometry.coordinates[0]];
          const polygonGeoJson: any = {
            type: "FeatureCollection",
            features: [{
              type: "Feature",
              properties: {
              },
              geometry: {
                type: "Polygon",
                coordinates: [polygonCoordinates]
              }
            }]
          };

          layerItem = L.geoJSON(
            polygonGeoJson, {
            style: geoJson.features[0].properties
          });

          if (text) {
            layerItem.bindTooltip(text).openTooltip();
          }

          this.checkboxItems.splice(2, 0, routeCheckBoxItem);
          this.filteredCheckboxItems.splice(2, 0, routeCheckBoxItem);
          this._loaderService.hide();
        })
        .catch((error: any) => {
          this._loaderService.hide();
          console.error('Error loading GeoJSON file:', error)
        });
    } else {
      this._loaderService.hide();
      console.error('Invalid GeoJSON file name:', fileName);
    }
  }

  // Markers
  private async _fillMapLocations(): Promise<void> {
    // Pluviometer
    this._pluviometerMarkers = this._generateMarker('pluviometer');
    this._markLocations(this._pluviometerMarkers, 'pluviometer');
    this.showHidePin('pluviometer');

    //WiFi
    this._wifiMarkers = this._generateMarker('wifi', false);
    this._wifiCirles = this._generateCircleMarker('wifi', 35, WifiCircleOptions);
    this._markLocations(this._wifiMarkers, 'wifi');
    this._markCircle(this._wifiCirles);
    this.showHidePin('wifi');
    this.showHidePin('wifiCircle');

    // Trash
    this._trashMarkers = this._generateMarker('trash');
    this._markLocations(this._trashMarkers, 'trash');
    this.showHidePin('trash');

    // Hospital
    this._hospitalMarkers = this._generateMarker('hospital');
    this._markLocations(this._hospitalMarkers, 'hospital');
    this.showHidePin('hospital');

    // Police
    this._policeMarkers = this._generateMarker('police');
    this._markLocations(this._policeMarkers, 'police');
    this.showHidePin('police');

    // Panel
    this._panelMarkers = this._generateMarker('panel');
    this._markLocations(this._panelMarkers, 'panel');
    this.showHidePin('panel');

    //Gateway
    this._gateways = await this._getGateways();
    this._gatewayMarkers = this._generateMarker('gateway');
    this._gatewayCircles = this._generateCircleMarker('gateway', 1800, GatewaysCircleOptions);
    this._markLocations(this._gatewayMarkers, 'gateway');
    this._markCircle(this._gatewayCircles);
    this.showHidePin('gateway');
    this.showHidePin('gatewayCircle');

    //Sensors
    try {
      this._getSensors('/topic/emco2');
      //this._getSensors('/topic/em310');
      this._getSensors('/topic/ws302');
      this._getSensors('/topic/emudl');
    } catch (error) {
      console.error(error)
    }
  }

  private _getMarkerList(sensorType: string) {
    switch (sensorType) {
      case 'pluviometer':
        return this._pluviometerMarkers;

      case 'trash':
        return this._trashMarkers;

      case 'gateway':
        return this._gatewayMarkers;

      case 'gatewayCircle':
        return this._gatewayCircles;

      case 'location':
        return [this._currentLocationMarker];

      case 'hospital':
        return this._hospitalMarkers;

      case 'police':
        return this._policeMarkers;

      case 'wifi':
        return this._wifiMarkers;

      case 'wifiCircle':
        return this._wifiCirles;

      case 'panel':
        return this._panelMarkers;

      case '/topic/em310':
        return this._EM310Markers;

      case '/topic/emco2':
        return this._CO2Markers;

      case '/topic/ws302':
        return this._WS302Markers;

      case '/topic/emudl':
        return this._EMUDLMarkers;

      default:
        return [];
    }
  }

  private _updateMarkerList(topic: string, markerList: any[]): void {
    switch (topic) {
      case '/topic/em310':
        this._EM310Markers = markerList;
        break;

      case '/topic/emco2':
        this._CO2Markers = markerList;
        break;

      case '/topic/ws302':
        this._WS302Markers = markerList;
        break;

      case '/topic/emudl':
        this._EMUDLMarkers = markerList;
        break;
    }
  }

  private _markLocations(markerList: L.Marker[], type: any): void {
    let icon: L.Icon<any> = this._getIcon(type);

    markerList.forEach((marker: L.Marker) => {
      marker.setIcon(icon);
      marker.addTo(this._map);
    });
  }

  private _markCircle(elementList: L.Circle[]): void {
    elementList.forEach((circle: L.Circle) => {
      this._map.addLayer(circle);
    });
  }

  private _generateSensorMarkers(list: any[], icon: any, type: string): L.Marker<any>[] {
    let listMarker: L.Marker<any>[] = [];

    list
      .filter((sensor: any) => sensor.payload)
      .map((sensor: any) => {
        let coords = {
          lat: this._parseLocation(sensor?.payload?.deviceInfo?.tags?.Location)?.lat,
          lng: this._parseLocation(sensor?.payload?.deviceInfo?.tags?.Location)?.lng
        }

        let marker = new L.Marker([coords.lat, coords.lng]);
        (marker as any).options.payload = sensor?.payload;
        marker.setIcon(icon);
        marker.bindPopup(this._getPopUpContent(type, sensor));

        listMarker.push(marker);
      });

    return listMarker;
  }

  private _generateMarker(type: string, hasPopUp: boolean = true): L.Marker<any>[] {
    let list: L.Marker<any>[] = [];
    let elementList = this._getList(type);

    elementList.forEach((element: any) => {
      let marker = new L.Marker([element.location.coords.lat, element.location.coords.lng]);

      if (hasPopUp) {
        marker.bindPopup(this._getPopUpContent(type, element));
      }

      list.push(marker);
    });

    return list;
  }

  private _generateCircleMarker(sensorType: string, radius: number, circleOptions: any): L.Circle<any>[] {
    let list: L.Circle<any>[] = [];
    let elementList = this._getList(sensorType);

    elementList.forEach((element: any) => {
      let marker = L.circle([element.location.coords.lat, element.location.coords.lng], { radius: radius, ...circleOptions })
      list.push(marker);
    });

    return list;
  }

  //Gateway
  private async _getGateways(): Promise<any[]> {
    try {
      const res: any = await firstValueFrom(this._ciCoreApi.getGateways());
      let data: any = [];
      res.data.map((obj: any) => {
        data.push({
          name: obj.name,
          location: {
            address: obj.name,
            coords: {
              lat: obj.location.latitude,
              lng: obj.location.longitude,
              alt: obj.location.altitude
            }
          },
          photo: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FIoT%2Fgateway.png?alt=media&token=7be3335b-ea81-4a97-bfe4-0eaaced1885a'
        })
      })
      return data;
    } catch (error) {
      console.error(error);
      return Gateways;
    }
  }

  private _combineGatewaysData(list: any[]): any[] {
    let gateways = Gateways.map(staticGateway => {
      const matchingApiGateway = list.find(apiGateway => apiGateway.name === staticGateway.id);
      if (matchingApiGateway) {
        return {
          ...staticGateway,
          data: {
            status: matchingApiGateway.state,
            location: matchingApiGateway.location
          }
        };
      } else {
        return staticGateway;
      }
    });
    return gateways;
  }

  // Sensors
  private _getSensors(topic: string): void {
    this._webSocketRxService.subscribeToTopic(topic);
    this._webSocketRxService.messages$
      .pipe(
        filter((msg: any) => msg?.headers["destination"] == topic)
      )
      .subscribe((msg: any) => {
        if (msg != null) {
          this.updateSensorInfo(topic, JSON.parse(msg.body));
        }
      })
  }

  // private updateSensorInfo(topic: string, sensorData: any) {
  //   let elementList = this._getList(topic);

  //   let elementListMarker: any = this._getMarkerList(topic);
  //   let icon: any = this._getIcon(topic);

  //   const sensorIndex = elementList.findIndex((sensor: any) => sensor.deviceName === sensorData.deviceInfo.deviceName);

  //   if (sensorIndex > -1) {
  //     elementList[sensorIndex].payload = sensorData;
  //     this._updateSensorList(topic, elementList);

  //     elementListMarker.forEach((marker: L.Marker) => {
  //       if (this._map.hasLayer(marker)) {
  //         this._map.removeLayer(marker);
  //       }
  //     });

  //     elementListMarker = this._generateSensorMarkers(elementList, icon, topic);
  //     this._updateMarkerList(topic, elementListMarker);

  //     this.showHidePin(topic);
  //     localStorage.setItem(topic, JSON.stringify(this._getList(topic)));

  //     // if (!this._doesCheckBoxItemExist(topic)) {
  //     //   let checkboxBase = getCheckboxSettings(topic);
  //     //   const sensorCheckBoxItem = this._createSensorCheckBoxItem(checkboxBase);

  //     //   this.checkboxItems.push(sensorCheckBoxItem);
  //     //   this.filteredCheckboxItems.push(sensorCheckBoxItem);
  //     //   this.showHidePin(topic);
  //     // }
  //   }
  // }



  private updateSensorInfo(topic: string, sensorData: any) {
    let elementList = this._getList(topic);
    let elementListMarker: any = this._getMarkerList(topic);
    let icon: any = this._getIcon(topic);
    const sensorIndex = elementList.findIndex((sensor: any) => sensor.deviceName === sensorData.deviceInfo.deviceName);
    if (sensorIndex > -1) {
      elementList[sensorIndex].payload = sensorData;
      this._updateSensorList(topic, elementList);
      const markerIndex = elementListMarker.forEach((element: any, index: any) => {
        return element.options.payload.deviceInfo.deviceName === sensorData.deviceInfo.deviceName ? index : -1;
      });
      if (markerIndex > -1) {
        elementListMarker[markerIndex] = this._createSensorMarker(sensorData, icon, topic);
        elementListMarker[markerIndex].options.payload = sensorData;
        elementListMarker[markerIndex].bindPopup(this._getPopUpContent(topic, { payload: sensorData }));
        if (this._map.hasLayer(elementListMarker[markerIndex])) {
          this._map.removeLayer(elementListMarker[markerIndex]);
        }
        if (this.activeLayers.has(topic)) {
          this._map.addLayer(elementListMarker[markerIndex]);
        }
      } else {
        const newMarker = this._createSensorMarker(sensorData, icon, topic);
        elementListMarker.push(newMarker);
        if (this._map.hasLayer(newMarker)) {
          this._map.removeLayer(newMarker);
        }
        if (this.activeLayers.has(topic)) {
          this._map.addLayer(newMarker);
        }
      }
      this._updateMarkerList(topic, elementListMarker);
      localStorage.setItem(topic, JSON.stringify(this._getList(topic)));
    }
  }

  private _createSensorMarker(sensorData: any, icon: any, topic: string): L.Marker {
    const marker = L.marker(
      [
        this._parseLocation(sensorData?.deviceInfo?.tags?.Location)?.lat,
        this._parseLocation(sensorData?.deviceInfo?.tags?.Location)?.lng
      ], {
      icon: icon
    });

    marker.bindPopup(this._getPopUpContent(topic, { payload: sensorData }));
    (marker as any).options.payload = sensorData;

    return marker;
  }

  private _doesCheckBoxItemExist(id: string): boolean {
    return this.checkboxItems.some(item => item.id === id);
  }

  private _createSensorCheckBoxItem(item: any): any {
    let icon: any = this._getIcon(item.icon)

    return {
      label: item.label,
      isChecked: true,
      functions: [
        (event: any) => this.showHidePin(item.slug)
      ],
      icon: icon.options.iconUrl,
      disabled: true,
      id: item.slug,
      tabs: item.tabs,
      layers: item.layers
    };
  }

  private _updateSensorList(topic: string, sensorList: any[]): void {
    switch (topic) {
      case '/topic/em310':
        this._EM310Sensors = sensorList;
        break;

      case '/topic/emco2':
        this._CO2Sensors = sensorList;
        break;

      case '/topic/ws302':
        this._WS302Sensors = sensorList;
        break;

      case '/topic/emudl':
        this._EMUDLSensors = sensorList;
        break;
    }
  }

  //Safe Taxi
  public openSafeTaxiChecker() {
    this.showTaxiChecker = true;
    this._cdr.detectChanges();
  }

  public closeSafeTaxiChecker() {
    this.showTaxiChecker = false;
    this._cdr.detectChanges();
  }

  // Utils
  private _getList(type: string): any[] {
    let elementList: any[] = [];

    switch (type) {
      case 'pluviometer':
        elementList = Pluviometers;
        break;

      case 'wifi':
        elementList = WifiPoints;
        break;

      case 'trash':
        elementList = TrashContainers;
        break;

      case 'hospital':
        elementList = Hospitals;
        break;

      case 'police':
        elementList = Police;
        break;

      case 'panel':
        elementList = Panels;
        break;

      case 'gateway':
        elementList = this._gateways;
        break;

      case '/topic/emco2':
        elementList = this._CO2Sensors;
        break;

      case '/topic/em310':
        elementList = this._EM310Sensors;
        break;

      case '/topic/ws302':
        elementList = this._WS302Sensors;
        break;

      case '/topic/emudl':
        elementList = this._EMUDLSensors;
        break;
    }

    return elementList;
  }

  private _getIcon(sensorType: string): L.Icon<any> {
    let icon: L.Icon<any> = new L.Icon({});

    switch (sensorType) {
      case 'pluviometer':
        icon = pluviometerIcon;
        break;

      case '/topic/em310':
        icon = levelSensorIcon;
        break;

      case '/topic/emco2':
        icon = co2SensorIcon;
        break;

      case '/topic/ws302':
        icon = soundSensorIcon;
        break;

      case '/topic/emudl':
        icon = levelSensorBlueIcon;
        break;

      case 'trash':
        icon = trashIcon;
        break;

      case 'gateway':
        icon = gatewayIcon;
        break;

      case 'bikeway':
        icon = bikeIcon;
        break;

      case 'hospital':
        icon = hospitalIcon;
        break;

      case 'police':
        icon = policeIcon;
        break;

      case 'wifi':
        icon = wifiIcon;
        break;

      case 'restriction':
        icon = restrictionIcon;
        break;

      case 'panel':
        icon = panelIcon;
        break;
    }

    return icon;
  }

  private _getCheckboxName(type: string): string {
    let name: string = '';

    switch (type) {
      case 'bikeway':
        name = 'Ciclovía';
        break;

      case 'restriction':
        name = 'Restric. vehicular';
        break;
    }

    return name;
  }

  private _onLocationFound(e: any): void {
    const cbbaBounds = {
      north: -17.2600,
      south: -17.5100,
      east: -66.1200,
      west: -66.2600
    };

    const isInCochabamba = e.latlng.lat <= cbbaBounds.north &&
      e.latlng.lat >= cbbaBounds.south &&
      e.latlng.lng <= cbbaBounds.east &&
      e.latlng.lng >= cbbaBounds.west;

    if (isInCochabamba) {
      this._currentLocationMarker = L.marker([e.latlng.lat, e.latlng.lng]);
      this._currentLocationMarker.setIcon(currentLocationIcon);
      this._currentLocationMarker.addTo(this._map).bindPopup(this._getPopUpContent('currentLocation', {}));
      this._currentLocationMarker.openPopup();
    } else {
      this._setCbbaLocation();
    }
  }


  public showHidePin(type: string) {
    let elementList: any = this._getMarkerList(type);
    elementList.forEach((marker: L.Marker) => {
      if (!this._map.hasLayer(marker)) {
        marker.addTo(this._map);
      } else {
        marker.remove();
        marker.removeFrom(this._map);
        this._map.removeLayer(marker);
      }
    });
  }

  public execCheckboxFunctions(index: number) {
    this.filteredCheckboxItems[index].isChecked = !this.filteredCheckboxItems[index].isChecked;
    this.countCheckedItems();
    this.filteredCheckboxItems[index].functions.forEach((fn: Function) => fn());
    if (this.activeLayers.has(`/topic/${this.filteredCheckboxItems[index].id}`)) {
      this.activeLayers.delete(`/topic/${this.filteredCheckboxItems[index].id}`)
    } else {
      this.activeLayers.add(`/topic/${this.filteredCheckboxItems[index].id}`);
    }
  }

  public closeDialog() {
    this.isVisible = !this.isVisible;
    this._cdr.detectChanges();
  }

  public countCheckedItems(): void {
    this.checkedItemsLength = this.filteredCheckboxItems.reduce((count, item) => count + (item.isChecked ? 1 : 0), 0);
    this._cdr.markForCheck();
  }

  private _parseLocation(location: string): { lat: number; lng: number } {
    const defaultCoords = { lat: -17.39489154204724, lng: -66.1599819897484 };

    if (!location) return defaultCoords;

    const [lat, lng] = location.split(',').map(coord => parseFloat(coord.trim()));

    return (!isNaN(lat) && !isNaN(lng)) ? { lat, lng } : defaultCoords;
  }

  private _getPopUpContent(type: string, item: any): L.Popup {
    const popUp: L.Popup = L.popup();
    let content: string = '';

    switch (type) {
      case 'pluviometer':
        content = getPluviometerPopUp(item);
        break;

      case 'gateway':
        content = getGatewayPopUp(item);
        break;

      case 'trash':
        content = getTrashPopUp(item);
        break;

      case 'hospital':
        content = getTrashPopUp(item);
        break;

      case 'police':
        content = getTrashPopUp(item);
        break;

      case 'currentLocation':
        content = getCurrentLocationPopUp();
        break;

      case 'sensor':
        content = getGenericSensorPopUp(item);
        break;

      case '/topic/em310':
        content = getBaseSensorPopUp(item, '/topic/em310');
        break;

      case '/topic/emco2':
        content = getBaseSensorPopUp(item, '/topic/emco2');
        break;

      case '/topic/ws302':
        content = getBaseSensorPopUp(item, '/topic/ws302');
        break;

      case '/topic/emudl':
        content = getBaseSensorPopUp(item, '/topic/emudl');
        break;

      case 'panel':
        content = getGenericPanelPopUp(item);
        break;
    }

    popUp.setContent(content);
    return popUp;
  }
}
